import Vue from 'vue'
import VueRouter from 'vue-router'
import AccountSettings from '../views/AccountSettings.vue'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Loan from '../views/Loan.vue'
import Borrower from '../views/Borrower.vue'
import Earnings from '../views/Earnings.vue'
import ForgotPassword from '../views/ForgotPassword.vue'
import ResetPassword from '../views/ResetPassword.vue'
import AllReports from '../views/AllReports.vue'
import Library from '../views/Library.vue'
import CusipAgreement from '../views/CusipAgreement.vue'
import QR from '../views/QR.vue'
import SoftToken from '../views/SoftToken.vue'
import * as cognosLaunch from '../utils/cognoslaunch.js';

Vue.use(VueRouter)

const routes = [
  { path: '/CR/home/:lenderId', name: 'home', component: Home, meta: {requiresAuth: true} },
  { path: '/CR/accountsettings', name: 'accountsettings', component: AccountSettings, meta: {requiresAuth: true} },
  { path: '/CR/forgotpassword', name: 'forgotpassword', component: ForgotPassword },
  { path: '/CR/resetpassword', name: 'resetpassword', component: ResetPassword, props(route) { return route.query || {} } },
  { path: '/CR/login', name: 'login', component: Login },
  { path: '/CR/loan', name: 'loan', component: Loan, meta: {requiresAuth: true} },
  { path: '/CR/borrower', name: 'borrower', component: Borrower, meta: {requiresAuth: true} },
  { path: '/CR/earnings', name: 'earnings', component: Earnings, meta: {requiresAuth: true} },
  { path: '/CR/allreports', name: 'allreports', component: AllReports, meta: {requiresAuth: true} },
  { path: '/CR/library', name: 'library', component: Library, meta: {requiresAuth: true} },
  { path: '/CR/cusipagreement', name: 'cusipagreement', component: CusipAgreement, meta: {requiresAuth: true} },
  { path: '/CR/qr', name: 'qr', component: QR, meta: {requiresAuth: true}},
  { path: '/CR/softtoken', name: 'softtoken', component: SoftToken, meta: {requiresAuth: true} },
  { path: '*', redirect: { name: 'login' } }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    var token = null
    if(to.name == 'qr' || to.name == 'softtoken') {
      token = sessionStorage.getItem('pre-web-token')
    } else {
      token = sessionStorage.getItem('web-token')
    }
    
    if (token) {
      next()
      return
    }
    
    cognosLaunch.logoffCognos();
    sessionStorage.clear();
    
    setTimeout(() => {
      window.location.href = "/CR/"
    }, 1000)
    return

  }
  next()
})

export default router
